import { render, staticRenderFns } from "./VehicleAveragePriceShowroom.vue?vue&type=template&id=37def1f4&"
import script from "./VehicleAveragePriceShowroom.vue?vue&type=script&lang=js&"
export * from "./VehicleAveragePriceShowroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports